import numeral from "numeral";

export default function formatFinancialValue(value: number | null): string {
  if (value === 0 || value === null) {
    return "0";
  }

  return numeral(value / 1000 / 1000)
    .format("0,000")
    .replace(/,/g, ".")
    .replace(".000.000", ".000");
}
